import { Fragment, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const CSVViewer = ({ base64String }: { base64String: string }) => {
  const [csvError, setCsvError] = useState(false);
  const [csvData, setCsvData] = useState<string[][] | null>(null);

  const decodeBase64 = (base64String: string) => {
    try {
      return atob(base64String);
    } catch (error) {
      console.error("Base64 decoding error:", error);
      setCsvError(true);
      return null;
    }
  };

  const parseCSV = (csvString: string) => {
    const rows = csvString?.split("\n").map((row) => row.split(","));
    return rows;
  };

  useEffect(() => {
    const decodedString = decodeBase64(base64String);
    const parsedData = parseCSV(decodedString as string);
    setCsvData(parsedData);
  }, [base64String]);

  useEffect(() => {
    return () => setCsvError(false);
  }, []);

  return (
    <div>
      {csvError ? (
        <div style={{ color: "#FFF" }}>
          Something went wrong with the CSV file
        </div>
      ) : (
        <Fragment>
          {csvData && (
            <table>
              <thead>
                <tr>
                  {csvData[0].map((header) => (
                    <th key={uuidv4()}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {csvData.slice(1).map((row) => (
                  <tr key={uuidv4()}>
                    {row.map((cell) => (
                      <td key={uuidv4()}>{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Fragment>
      )}
    </div>
  );
};

export default CSVViewer;
